export default __webpack_public_path__ + "static/media/nocny-turnaj.569caf2f.svg";